var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaestro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3C1 1.89543 1.89543 1 3 1H23C24.1046 1 25 1.89543 25 3V15C25 16.1046 24.1046 17 23 17H3C1.89543 17 1 16.1046 1 15V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7765 8.945C14.7765 11.676 12.588 13.89 9.88825 13.89C7.18855 13.89 5 11.676 5 8.945C5 6.21395 7.18855 4 9.88825 4C12.588 4 14.7765 6.21395 14.7765 8.945Z",
    fill: "#ED0006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1178 8.945C21.1178 11.676 18.9293 13.89 16.2296 13.89C13.5299 13.89 11.3413 11.676 11.3413 8.945C11.3413 6.21395 13.5299 4 16.2296 4C18.9293 4 21.1178 6.21395 21.1178 8.945Z",
    fill: "#0099DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0593 12.7087C14.1103 11.8016 14.7767 10.452 14.7767 8.94497C14.7767 7.4379 14.1103 6.08829 13.0593 5.18129C12.0082 6.08829 11.3418 7.4379 11.3418 8.94497C11.3418 10.452 12.0082 11.8016 13.0593 12.7087Z",
    fill: "#6C6BBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2H23V0H3V2ZM24 3V15H26V3H24ZM23 16H3V18H23V16ZM2 15V3H0V15H2ZM3 16C2.44772 16 2 15.5523 2 15H0C0 16.6569 1.34314 18 3 18V16ZM24 15C24 15.5523 23.5523 16 23 16V18C24.6569 18 26 16.6569 26 15H24ZM23 2C23.5523 2 24 2.44771 24 3H26C26 1.34315 24.6569 0 23 0V2ZM3 0C1.34315 0 0 1.34315 0 3H2C2 2.44772 2.44772 2 3 2V0Z",
    fill: "#E1DEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/maestro.5ec6544f272b05e09ede9ec2912b8684.svg";
export { ForwardRef as ReactComponent };